// @ts-nocheck

import { t } from "i18next";
// Generator
import FormChoicesOption from "./components/FormGenerator/components/QuestionTypes/FormChoices/FormChoicesOption";
import FormRangeOption from "./components/FormGenerator/components/QuestionTypes/Range/FormRangeOption";
import FormTextOption from "./components/FormGenerator/components/QuestionTypes/Text/FormTextOption";
// Filler
import TextFiller from "./components/FormViewer/components/FormQuestion/components/Text/FormTextOption";
import ChoicesFiller from "./components/FormViewer/components/FormQuestion/components/FormChoices/FormChoicesOption";
import RangeFiller, {formRangOptionChecker} from "./components/FormViewer/components/FormQuestion/components/Range/FormRangeOption";
//Answers
import {
	ChoicesQuestionViewer,
	TextQuestionViewer,
	RangeQuestionViewer
} from "./components/FormAnswersPreview/FormAnswersPreview";

const getQuestionsTypes = () => [
	{
		questionDesignId: 1,
		type: "ShortText",
		title: t("Forms.SHORT_TEXT"),
		component: FormTextOption,
		filler: TextFiller,
		viewer: TextQuestionViewer
	},
	{
		questionDesignId: 6,
		type: "LongText",
		title: t("Forms.LONG_TEXT"),
		component: FormTextOption,
		filler: TextFiller,
		viewer: TextQuestionViewer
	},
	{
		questionDesignId: 7,
		type: "UniqueChoice",
		title: t("Forms.UNIQUE_CHOICES"),
		multiple: true,
		uniqueChoice: true,
		component: FormChoicesOption,
		filler: ChoicesFiller,
		viewer: ChoicesQuestionViewer
	},
	{
		questionDesignId: 8,
		type: "MultipleChoice",
		title: t("Forms.MULTIPLE_CHOICE"),
		multiple: true,
		component: FormChoicesOption,
		filler: ChoicesFiller,
		viewer: ChoicesQuestionViewer
	},
	{
		questionDesignId: 9,
		type: "BasicRange",
		title: t("Forms.RANGE_INPUT"),
		component: FormRangeOption,
		filler: RangeFiller,
		fillValidation: formRangOptionChecker,
		viewer: RangeQuestionViewer
	},
	// {
	// 	typeId: 10,
	// 	type: "buttons",
	// 	title: t("Forms.SHORT_TEXT"),
	// 	multiple: true,
	// },
];

export function getQuestionType(typeIdOrName) {
	if (!typeIdOrName)
		return (false);
	let types = getQuestionsTypes();
	let found = types.find((a) => (a.questionDesignId === typeIdOrName || a.type === typeIdOrName));
	return (found || false)
}

export default getQuestionsTypes;
